export default "__VITE_ASSET__7d31cef7__"